import { render, staticRenderFns } from "./Kolkin.vue?vue&type=template&id=5ae58b8a"
import script from "./Kolkin.vue?vue&type=script&lang=js"
export * from "./Kolkin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports